export const MarketingBanner = () => {
    const scripts = `
        const isBannerClosed = sessionStorage.getItem('marketing-banner-closed') === 'true';
        const banner = document.getElementById('marketing-banner');
        
        if (banner && isBannerClosed) {
            banner.style.display = 'none';
        } else {    
            document.querySelector('#marketing-banner-close-btn').addEventListener('click', (e) => {
                e.stopPropagation();
                if (banner) {
                    banner.style.display = 'none';
                    sessionStorage.setItem('marketing-banner-closed', 'true');
                }
            });
            document.querySelector('#marketing-banner').addEventListener('click', () => {
                sessionStorage.setItem('marketing-banner-closed', 'true');
                window.location.href = '/?geo=1&command=search_location&region=2&miejsca_dorosli=2&miejsca_dzieci=0&miejsca=2&rezerwacja_online=1&kategoria_nonprofitowa=0&region_rezerwacje_online=0&utm_source=site&utm_medium=text_baner&utm_campaign=summer_pl_2025';
            });
        }
    `;

    const styles = `
        #marketing-banner {
            font-size: 1rem;
            width: '100%';
            background-color: #0050A0;
            color: #FFFFFF;
            padding: 10px 16px;
            display: grid;
            grid-template-columns: 1fr auto;
            grid-gap: 1rem;
            align-items: center;
            cursor: pointer;
        }
        #marketing-banner-close-btn {
            cursor: pointer;
            font-size: 20px;
            background: none;
            border: none;
            outline: none;
            color: white;
            padding: 0.625rem 1rem;
            margin: -0.625rem -1rem;
        }
        .marketing-banner-content--desktop {
            display: block;
        }
        .marketing-banner-content--mobile {
            display: none;
        }
        .marketing-banner-link {
            border: 1px solid #FFFFFF;
            padding: 0.25rem 1rem;
            margin-left: 0.75rem;
            border-radius: 0.25rem;
            display: inline-flex;
            align-items: center;
            gap: 0.25rem;
            transition: 0.3s;
            
            &:hover {
                background: #FFFFFF;
                color: #0050A0;
            }
        }
        .marketing-banner-link__chevron {
            line-height: 0.5;
            font-size: 2rem;
            margin-left: 0.25rem;
            margin-bottom: 0.125rem;
        }

        @media (max-width: 767px) {
            #marketing-banner {
                font-size: 0.875rem;
            }
            .marketing-banner-content--desktop {
                display: none;
            }
            .marketing-banner-content--mobile {
                display: block;
                width: 100%;
            }
            .marketing-banner-link {
                border: none;
                margin-left: 0.375rem;
                padding: 0;
                vertical-align: sub;
            }
            .marketing-banner-link__chevron {
                margin-bottom: 0;
            }
        }
    `;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />

            <div id="marketing-banner">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div className="marketing-banner-content--desktop">
                        Słońce, plaża i Ty - znajdź i
                        <span style={{ fontWeight: '700' }}> zarezerwuj nocleg online</span> nad
                        polskim morzem.
                        <button className="marketing-banner-link">
                            <span className="marketing-banner-link__text">Zobacz oferty</span>
                            <span className="marketing-banner-link__chevron">&#8250;</span>
                        </button>
                    </div>
                    <div className="marketing-banner-content--mobile">
                        Słońce, plaża i Ty - znajdź i
                        <span style={{ fontWeight: '700' }}> zarezerwuj nocleg online </span>
                        nad polskim morzem.
                        <button className="marketing-banner-link">
                            <span className="marketing-banner-link__chevron">&#8250;</span>
                        </button>
                    </div>
                </div>
                <button id="marketing-banner-close-btn" type="button">
                    ✕
                </button>
            </div>

            <script dangerouslySetInnerHTML={{ __html: scripts }} />
        </>
    );
};
